import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import { isNullable } from '@app/utils'
import { useMemo } from 'react'

export interface UseImageLoadingStateReturn {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
}

const QUERY_KEY = 'CHECK_IMAGE_QUERY_KEY'

const checkImage = async (src?: string): Promise<void> => {
  if (isNullable(src)) return
  return await axios.head(src)
}

const getSrcWithoutHash = (src?: string): string | undefined => {
  const withoutHashRgx = /\S*.(jpg|jpeg|png)/
  return src?.match(withoutHashRgx)?.[0]
}

export const useImageLoadingState = (src?: string): UseImageLoadingStateReturn => {
  const srcWithoutHash = useMemo(() => getSrcWithoutHash(src), [src])

  const { isLoading, isSuccess, isError } = useQuery({
    retry: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    queryKey: [QUERY_KEY, srcWithoutHash],
    queryFn: async () => await checkImage(src)
  })

  return { isLoading, isSuccess, isError }
}
